import { ChangeDetectorRef, Component, ComponentFactoryResolver, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { SolarBaseComponent } from '@solar/solar/solar-base';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Site, InfoSite } from 'solar-bo';;
import { AppConfig } from '@solar/app.config';
import { MessageError } from 'base-models';
import { AlertType } from 'base-models';
import { CountryPickerService, ICountry } from 'basecomponents';
import { DialogdeleteComponent } from 'basecomponents';
import { SortHelper } from 'shtools';
import { ErrorcontrolService } from 'basecomponents';
import { SiteEditDlgComponent } from '../site-edit/site-edit-dlg.component';
import { TableList } from 'shtools';
import { TabComponent } from '@solar/components/maintab/tab.component';
import { SiteMainComponent } from '../site-main/sitemain.component';
import { MainTabComponent } from '@solar/components/maintab/maintab.component';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { TabItem } from '@solar/components/maintab/tabitem.model';
import { ActivatedRoute } from '@angular/router';
import { DBG, DebugLevelEnum } from '@solar/shared/dbg.model';
import { ISdsAction, SdsService } from '@solar/services';



@Component({
  selector: 'app-site-list-main',
  templateUrl: './site-list-main.component.html',
  styleUrls: ['./site-list-main.component.scss']
})
export class SiteListMainComponent extends SolarBaseComponent implements OnInit  {

  tabsComponents: TabItem[] = [];
  tab_selectedIndex = 0;
  //@ViewChild(MainTabComponent) tabsComponent:MainTabComponent;

  @ViewChild(MatTabGroup, { read: MatTabGroup }) public tabGroup: MatTabGroup;
  @ViewChildren(MatTab, { read: MatTab }) public tabNodes: QueryList<MatTab>;
  //@ViewChild('tablistcomp') tablistComp: TabsetComponent;


  constructor(private cdr: ChangeDetectorRef
    ,public route1: ActivatedRoute
    , private sdsService: SdsService) {
      
    super();
    this.TAG="SiteListMainComponent";
    this.loading = false;
    this.globService.routeReuseStrategyEvent.subscribe(event => this.routeReuseStrategyEventHandler(event));
    sdsService.actions.subscribe((action) => this.sdsServiceActionsHandler(action));
  }

  ngOnInit() {

  }

  private sdsServiceActionsHandler(action: ISdsAction) {
    if (action) {
        if (action.action == "SITESELECTED") {
          this.siteSelectedEventHandler(action.value) ;
        }
    }
}

  private routeReuseStrategyEventHandler(event: any) {
    let thisURL = (this.route1 as any)._routerState.snapshot.url;
     
    if (event.value != thisURL) {
      return;
    }
    if (event.type == "STORE") {
      //this.reuseStrategy_Detach();
    } else if (event.type == "RESTORE") {
      //DBG.log1(this, DebugLevelEnum.INFO, this.TAG, "routeReuseStrategyEventHandler", event, thisURL);
    }
  }

  openSite(id) {
    /*     let tab=new TabComponent();
        tab.title="Site " + id;
        tab.template=SiteMainComponent;
        tab.dataContext={id:id};
        this.pageTabs.push(tab); */
    //this.tabsComponent.openTab("Site " + id, SiteMainComponent, {siteId:id}, true);
  }

  siteSelectedEventHandler($event) {
    let site: Site = $event;
    //this.tabsComponent.openTab(site.name, SiteMainComponent, {siteId:site.id}, true);
    let tabExistIndex = this.findTabBy(site.id);
    if (tabExistIndex > -1) {
      this.tabGroup.selectedIndex = tabExistIndex + 1;//because we have at least 1 fixed we use total length
      return;
    }
    this.loadinglist = true;
    //setTimeout(() => this.loadinglist=true);    
    //this.cdr.detectChanges();
    setTimeout(() =>
      this.openTab(site.id, site.name, SiteMainComponent, { siteId: site.id }, true)
    );

  }

  openTab(id: any, title: string, component, data, isCloseable = false) {

    let instance: TabItem = new TabItem();
    instance.id = id;
    instance.title = title;
    instance.component = component;
    instance.dataContext = data;
    instance.active = true;
    instance.isCloseable = isCloseable;
    this.tabsComponents.push(instance);
    this.tabGroup.selectedIndex = this.tabsComponents.length;//because we have at least 1 fixed we use total length
    this.loadinglist = false;
    return instance;

  }

  private loadTab(id: any, title: string, component, data, isCloseable = false) {

  }

  private findTabBy(id: any) {
    let index = this.tabsComponents.findIndex(item => item.id == id);
    return index;
  }

  closeTab(index: number, tab?: any) {
    event.stopPropagation();
    this.tabsComponents.splice(index, 1);
    this.tabGroup.selectedIndex = this.tabNodes.length - 1;
  }

  onSelectTab($event) {
    switch ($event.id) {
      case "tab_sitelist":

        break;
    }
  }


}
